<template>
  <div class="search-result-page">
    <div class="container">
      <div class="title">
        搜索
      </div>
      <div>
        <header-search-input
          :showArrow="false"
          class="search-input"
          :keyword="searchContent"
          @change="onSearchInputChange"
          @searchCompany="onSearchCompany"
        ></header-search-input>
        <!-- <search-input :showArrow="false" class="search-input" :keyword="searchContent" @change="onSearchInputChange" @searchCompany="onSearchCompany" @arrowSearchCompany="arrowSearchCompany"></search-input> -->
      </div>
      <!-- <div class="company" v-show="liLength">
        <div class="company-title">为您找到 <span class="count">{{liLength}}</span> 家相关公司</div>
        <div class="box">
          <div id="box-container">
            <div class="card" v-for="(item, index) in machedCompanyList" :key="index" @click="onToCompanyPage(item.companyName)">
              <div class="company-name">{{item.companyName}}</div>
              <div class="score">热度 <span class="score-index">{{item.count}}</span></div>
            </div>
          </div>
        </div>
        <div class="shade shade-left" v-if="iNow"></div>
        <div class="shade shade-right" v-if="iNow!==liLength - 3"></div>
        <div v-if="showLeft" class="arrow arrow-left" @click="onLeftClick"><div class="triangle"></div></div>
        <div v-if="showRight&liLength > 3" class="arrow arrow-right" @click="onRightClick"><div class="triangle"></div></div>
      </div> -->
      <div class="news-list">
        <div class="news-title">相关新闻</div>
        <div class="news-list-content">
          <div class="row news-list-source-filter">
            <div class="total-count">共有{{totalCount}}条相关舆情</div>
            <div class="news-list-source-filter-right">
              <!-- <SnDatePicker @timeChange="timeChange"></SnDatePicker> -->
              <!-- <el-select class="select" v-model="source" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> -->
            </div>
          </div>
          <div class="news-list-detail" v-loading="isLoading">
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
              <news-list-item v-for="(item, idx) in resultData" :key="idx" :data="item"></news-list-item>
            </div>
          </div>
        </div>
        <div class="loading" v-if="pageItems && resultData.length"><div class="loading-word">加载中...</div></div>
        <div class="loading" v-if="!pageItems"><div class="loading-word">没有更多了</div></div>
        <div class="no-data-container" v-if="!isLoading && !resultData.length">
          <no-data></no-data>
        </div>
      </div>
    </div>
    <BackTop></BackTop>
  </div>
</template>

<script>
// import SearchInput from '@/components/common/SearchInput';
import HeaderSearchInput from '@/components/common/HeaderSearchInput';
import BackTop from '@/components/common/BackTop';
import QuestionQuery from '@/rest/questionQuery';
import NewsListItem from '@/components/news-monitor/SearchResultNewsListItem';
import Mark from 'mark.js';
import NoData from '@/components/common/NoData';
// import SnDatePicker from '@/components/common/SnDatePicker';

export default {
  data() {
    return {
      beforeItemData: [],
      liLength: 0,
      showRight: true,
      showLeft: false,
      oEmg: [],
      iNow: 0,
      searchText: '',
      resultData: [],
      loading: false,
      pageNum: 1,
      pageSize: 30,
      busy: false,
      machedCompanyList: [],
      highlight: [],
      searchContent: '',
      pageItems: [],
      isLoading: false,
      timer: null,
      source: '全部来源',
      totalCount: null,
      options: [
        {
          value: '全部来源',
          label: '全部来源'
        },
        {
          value: '官媒',
          label: '官媒'
        },
        {
          value: '公众号',
          label: '公众号'
        }
      ],
      date: []
    };
  },
  methods: {
    timeChange(date) {
      // eslint-disable-next-line
      this.date = date ? date : [];
      this.pageNum = 1;
      this.resultData = [];
      this.beforeItemData = [];
      this.getSearch();
    },
    onLeftClick() {
      if (this.iNow === this.liLength - 3) {
        this.showRight = true;
      }
      if (this.iNow === 1) {
        this.showLeft = false;
        this.iNow--;
        this.oEmg.style.left = `${-280 * (this.iNow)}px`;
        return;
      }
      this.iNow--;
      this.oEmg.style.left = `${-280 * (this.iNow)}px`;
    },
    onRightClick() {
      if (!this.iNow) {
        this.showLeft = true;
      }
      if (this.iNow === this.liLength - 4) {
        this.showRight = false;
        this.iNow++;
        this.oEmg.style.left = `${-280 * (this.iNow)}px`;
        return;
      }
      this.iNow++;
      this.oEmg.style.left = `${-280 * (this.iNow)}px`;
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.pageItems.length) {
        this.timer = setTimeout(() => {
          this.pageNum++;
          this.getSearch(true);
        }, 500);
      }
    },
    onSearchInputChange({ searchText, type }) {
      // this.searchContent = res;
      // this.pageNum = 1;
      // this.resultData = [];
      // this.beforeItemData = [];
      // this.getSearch();
      // this.getCompanies();
      if (type === 'company') {
        this.$router.push({
          name: 'result-page',
          query: {
            q: searchText
          }
        });
      } else if (type === 'person') {
        this.$router.push({
          name: 'person',
          query: {
            q: searchText
          }
        });
      }
    },
    onToCompanyPage(res) {
      this.$router.push({
        name: 'result-page',
        query: {
          q: res
        }
      });
    },
    arrowSearchCompany(res) {
      this.$router.push({
        name: 'result-page',
        query: {
          q: res
        }
      });
    },
    onSearchCompany(res) {
      this.searchContent = res;
      this.pageNum = 1;
      this.resultData = [];
      this.beforeItemData = [];
      this.getSearch();
      this.getCompanies();
    },
    getCompanies() {
      QuestionQuery.getCompanyNameSearchV1(this.searchContent).then(result => {
        if (result) {
          this.liLength = result.length;
          if (this.oEmg) {
            this.oEmg.style.width = `${(result.length) * 276}px`;
          }
        }
        this.machedCompanyList = result;
      });
    },
    getSearch() {
      this.isLoading = true;
      QuestionQuery.getSearchDataV1(this.pageNum, this.pageSize, this.searchContent, this.date).then(result => {
        this.isLoading = false;
        this.pageItems = result.pageItems;
        this.totalCount = result.totalCount;
        this.beforeItemData.forEach(item => {
          this.pageItems.forEach(i => {
            if (item.newsId === i.newsId) {
              this.pageItems.splice(this.pageItems.indexOf(i), 1);
            }
          });
        });
        this.beforeItemData = this.pageItems;
        if (result.pageItems.length) {
          this.highlight = result.highlight;
          this.resultData = this.resultData.concat(result.pageItems);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    }
  },
  computed: {
    disabled() {
      return this.loading;
    }
  },
  components: {
    HeaderSearchInput,
    NewsListItem,
    BackTop,
    // SnDatePicker
    NoData
  },
  watch: {
    $route(val) {
      this.searchContent = val.query.q || '';
      this.pageNum = 1;
      this.resultData = [];
      this.beforeItemData = [];
      this.getSearch();
      this.getCompanies();
    }
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.news-list-detail'));
    instance.mark(this.highlight || [], {
      element: 'span',
      className: 'highlight',
      exclude: ['.source']
    });
  },
  mounted() {
    eventBus.$emit('toOtherPage');
    this.oEmg = document.getElementById('box-container');
    this.searchContent = this.$route.query.q || '';
    this.getSearch();
    // this.getCompanies();
  }
};
</script>

<style lang="scss" scoped>
.loading {
  height: 10px;
  width: 804px;
  color: #747990;
  background: #ffffff;
  margin: auto;
  .loading-word {
    margin: 0 auto;
    width: 200px;
  }
}
  .search-result-page {
    width: 100%;
    min-height: 100%;
    background: rgba(247,248,252,1);
    .container {
      margin: 16px auto 0;
      width: 1200px;
      background: #ffffff;
      padding:12px 24px 0 ;
      .title {
        margin-bottom: 16px;
        color: #171f46;
        font-size: 24px;
      }
      .search-input {
        width: 600px;
        height: 40px;
        /deep/.search-input-container {
          .input-container {
            input {
              height: 40px;
            }
            .search-button {
              top: 8px;
            }
          }
        }
      }
      .company {
        position: relative;
        padding-top: 40px;
        .company-title {
          padding-bottom: 12px;
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
         
          .count {
            color: #ffffff;
          }
        }
        .box {
          height: 104px;
          width: 804px;
          position: relative;
          overflow: hidden;
          #box-container {
            width:2000px;
            position: absolute;
            left:0; 
            transition: left 0.5s cubic-bezier(0, 0, 0.32, 1);
            .card {
              float: left;
              position: relative;
              margin-right: 16px;
              padding: 16px 20px;
              width: 260px;
              height: 104px;
              background-color: #3e3c42;
              border-radius: 4px;
              cursor: pointer;
              &:hover {
                background-color: #45434a;
              }
              .company-name {
                font-size: 16px;
                color: #ffffff;
              }
              .score {
                position: absolute;
                left: 20px;
                bottom: 16px;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                .score-index {
                  color: #ffe536;
                  font-size: 14px;
                }
              }
            }
          }
          
        }
        .shade-left {
          position: absolute;
          top: 70px;
          left: 0;
          width: 60px;
          height: 104px;
          background-image: linear-gradient(90deg, #333138 0%, #3e3c4200 100%);
        }
        .shade-right {
          position: absolute;
          top: 70px;
          right: 0;
          width: 60px;
          height: 104px;
          background-image: linear-gradient(90deg, #3e3c4200 0%, #333138 100%);
        }
        .arrow {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.08);
        }
        .arrow-left {
          position: absolute;
          top: 106px;
          left: -16px;
          cursor: pointer;
          &:hover {
            background-color: rgba(255, 255, 255, 0.16);
            .triangle {
              opacity: 1;
            }
          }
          .triangle {
            position: absolute;
            left: 4px;
            top: 10px;
            width: 0px;
            height: 0px;
            border-top:6px solid transparent;
            border-bottom:6px solid transparent;
            border-right:7px solid transparent;
            border-left:7px solid transparent;
            border-right-color: #ffffff;
            opacity: 0.6;
          }
        }
        .arrow-right {
          position: absolute;
          top: 106px;
          right: -16px;
          cursor: pointer;
          &:hover {
            background-color: rgba(255, 255, 255, 0.16);
            .triangle {
              opacity: 1;
            }
          }
          .triangle {
            position: absolute;
            right: 4px;
            top: 10px;
            width: 0px;
            height: 0px;
            border-top:6px solid transparent;
            border-bottom:6px solid transparent;
            border-right:7px solid transparent;
            border-left:7px solid transparent;
            border-left-color: #ffffff;
            opacity: 0.6;
          }
        }
        
      }
      .news-list {
        padding-bottom: 12px;
        .no-data-container {
          height: 500px;
        }
        .news-list-content {
          overflow: hidden;
          border-radius: 8px;
          background-color: #ffffff;
          .news-list-source-filter {
            justify-content: space-between;
            margin-top: 16px;
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-top: 1px solid #f7f7fa;
            border-bottom: 1px solid #f7f7fa;
          .total-count {
            color: #747990;
            font-size: 12px;
          }
          .news-list-source-filter-right {
            .select {
              width: 106px;
            }
            /deep/ .el-input--suffix .el-input__inner{
              width: 106px;
              height: 26px;
              background-color: #F7F8FC;
              border: none;
              padding-left: 3px 12px;
              margin: 7px 0;
            }
            /deep/ .el-select .el-input .el-select__caret{
              color: #747990;
            }
          }
        }
        }
        ul {
          padding-left: 0;
          margin: 0;
        }
        li {
          list-style: none;
        }
        .news-title {
          margin-top: 32px;
          color: #464d6c;
          font-size: 14px;
        }
      }
    }
  }
</style>

